import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { vuetifyConfig } from '@girder/components/src';

Vue.use(Vuetify);

export default new Vuetify(vuetifyConfig);
